// @flow
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import { Box, Button, FormControl, IconButton } from "@mui/material";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid2";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import FormBoxTitle from "../../../../../components/mui/app/formBoxTitle/formBoxTitle";
import {
	formControlDefaults,
} from "../../../../../helpers/theme/defaultProps";
import { ISSUES_FORM } from "../../../locales/namespaces";
import AssetAutoComplete from "./assetAutoComplete";

type Props = {};

const Assets = (props: Props) => {
	const { t } = useTranslation(ISSUES_FORM)
	const { formik, initialAssets, theme } = props
	const addAsset = useCallback(() => {
		formik.setFieldValue('assets', [
			...formik.values.assets,
			{
				id: uuidv4(),
				asset: ''
			}
		])
	}, [formik])
	
	const removeAsset = useCallback((index) => {
		const updatedAssets = [...formik.values.assets]
		updatedAssets.splice(index, 1)
		formik.setFieldValue('assets', updatedAssets)
	}, [formik])
	
	const disableAddingAsset = useMemo(() => (!(Boolean(formik.values.AddressId?.id) && Boolean(formik.values.ItemId?.id))), [formik.values.AddressId?.id, formik.values.ItemId?.id])
	
	return (
		<Grid
			size={12}
		>
			<FormBoxTitle
				title={t('Assets')}
				children={
					<Button
						onClick={addAsset}
						variant={'text'}
						startIcon={<AddIcon/>}
						disabled={disableAddingAsset}
					>
						{t('Add')}
					</Button>
				}
			/>
			{formik.values.assets?.map((i, index) => {
				return (
					<Box key={i?.id} sx={{ borderLeft: `4px solid ${theme.palette.error.main}` }}>
						<Grid
							container
							spacing={1}
							sx={{ padding: 0.4, marginBottom: 0.8 }}
						>
							<Grid size={12}>
								<Box sx={{
									display: 'flex',
									justifyContent: 'flex-end',
									background: '#fff5ee',
									paddingLeft: 0.4,
									paddingRight: 0.4
								}}>
									<FormControl
										{...formControlDefaults}
										sx={{ display: 'inline' }}
									>
										<IconButton
											color="error"
											onClick={() => removeAsset(index)}
										>
											<ClearIcon/>
										</IconButton>
									</FormControl>
								</Box>
							</Grid>
							<Grid size={12}>
								<AssetAutoComplete
									initialAssets={initialAssets}
									index={index}
									value={i?.asset}
									formik={formik}
								/>
							</Grid>
						</Grid>
					</Box>
				)
			})}
		</Grid>
	);
};

export default Assets